<template>
   <div class="adminPage HomeEvalD">
      <modal
         name="InfoModal"
         width="400"
         height="auto"
         :scrollable="true"
         :adaptive="true"
         :clickToClose="true"
         >
         <div class="modalContainer errorModal">
            <div class="errorIcon">
               <i class="fa fa-times"></i>
            </div>
            <h3>Error</h3>
            <p>
               Actualmente este formulario presenta un error de plataforma,
               por favor comuníquese con su facultad.
            </p>
            <div class="modalActions">
               <button class="loginbtn secondaryBtn" @click="closeModal">
               Cerrar
               </button>
            </div>
         </div>
      </modal>
      <div class="titlePage">
         Evaluación Docente
      </div>
      <i
         class="fa fa-spinner fa-spin iconload"
         v-if="iconLoad"
         />
      <va-notification
         v-if="evalsExist === false"
         color="danger"
         class="refNoData"
         >
         No se encuentran formularios activos en este momento.
      </va-notification>
      <va-notification
         v-if="isBadDate"
         color="danger"
         class="refNoData"
         >
         No se encuentran formularios activos en este momento.
      </va-notification>
      <template v-else-if="evalsExist">
         <div class="adminCard">
            <div class="adminCardHeader">
               Cursos a evaluar para el periodo {{ period }}
            </div>
            <div class="adminCardBody">
               <div class="evalGrid">
                  <div
                     class="evalCard"
                     v-for="signature of signatures"
                     :key="signature.nombre_materia"
                     @click="evaluateTeacher(
                     signature.periodo_actual,
                     signature.nrc_materia,
                     idStudent,
                     signature.id_banner_docente,
                     signature.nombre_materia)"
                     >
                     <i class="fa fa-book evalIcon"></i>
                     <div v-for="formsuc of formSuccess" :key="formsuc">
                        <i
                           class="fa fa-check evaluated"
                           v-if="formsuc === signature.nrc_materia+'-'+signature.nombre_materia"
                           />
                     </div>
                     <div v-for="formerr of formError" :key="formerr">
                        <i
                           class="fa fa-times evalerror"
                           v-if="formerr === signature.nrc_materia"
                           />
                     </div>
                     <h3>{{signature.nombre_materia}}</h3>
                     <p>Docente:</p>
                     <span>{{signature.nombre_docente}}</span>
                  </div>
               </div>
            </div>
         </div>
      </template>
   </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'
export default {
  name: 'EvalDocente',
  components: {},
  data () {
    return {
      period: [],
      signatures: [],
      idBanner: [],
      form: null,
      formType: null,
      formSuccess: [],
      formError: [],
      evalsExist: null,
      teacherId: [],
      idStudent: null,
      roleUser: null,
      iconLoad: true,
      isBadDate: false,
    }
  },
  methods: {
    closeModal () {
      this.$modal.hide('InfoModal')
    },
    getAnswer (idbanner) {
      var teacherId = IberoHelpers.GetIdPersonByIdBanner(this.$store, idbanner)
      teacherId.then(teacherIdData => {
        //console.log(teacherIdData.data[0].Id_Person)
      })
    },
    evalExist (period, signature, nameSignature) {
      let sig = signature + '-' + nameSignature
      var formS = IberoHelpers.GetFormSuccess(this.$store, this.idStudent, period, sig)
      formS.then(dataFormR => {
        if (dataFormR.data) {
          this.formSuccess.push(dataFormR.data[0].NRC)
        }
      })
    },
    evalError (idbannerteacher, signature) {
      const teacherId = IberoHelpers.GetIdPersonByIdBanner(this.$store, idbannerteacher)
      teacherId.then(teacherIdData => {
        if (!teacherIdData.data) {
          this.formError.push(signature)
        }
      })
    },
    evaluateTeacher (period, signature, idstudent, idbannerteacher, signatureName) {
      let sig = signature + '-' + signatureName
      var formS = IberoHelpers.GetFormSuccess(this.$store, this.idStudent, period, sig)
      formS.then(dataFormR => {
        console.log(dataFormR)
        if (dataFormR.data) {
          // ya evaluado
        } else {
          const teacherId = IberoHelpers.GetIdPersonByIdBanner(this.$store, idbannerteacher)
          teacherId.then(teacherIdData => {
            if (teacherIdData.data) {
              const evalData = {
                form: this.form,
                period,
                signature,
                signatureName,
                idstudent,
                idbannerteacher,
                role: this.roleUser,
                formType: this.formType,
              }
              this.$session.set('evalDo', evalData)
              this.$router.push('/admin/FormEvalDocente/')
            } else {
              this.$modal.show('InfoModal')
            }
          })
        }
      })
    },
    getFormId (role, actualPeriod, formType) {
      const dataForm = IberoHelpers.getEvalForm(this.$store, role, actualPeriod, formType)
      dataForm.then(getForm => {
        if (getForm.data) {
          this.evalsExist = true
          this.form = getForm.data[0].Id_Generic_Form
          this.roleUser = role
          this.iconLoad = false
        } else {
          this.evalsExist = false
          this.iconLoad = false
        }
      })
    },
  },
  created () {

  },
  mounted () {
    let loader = this.$loading.show()
    this.idStudent = this.$session.get('IberoJWTAdminLogin').idPerson
    var data = IberoHelpers.getSignature(this.$store,this.$session.get('IberoJWTAdminLogin').idBanner)
    // var data = IberoHelpers.getSignature(this.$store, '100088921')
    data.then(Response => {
      if (Response.data != '') {
        this.period = Response.data[0].periodo_actual
        this.signatures = Response.data
        this.idStudent = this.$session.get('IberoJWTAdminLogin').idPerson
        /* -------------------------------------------------------------- */
        for (let i = 0; i < Response.data.length; i++) {
          this.evalExist(Response.data[i].periodo_actual, Response.data[i].nrc_materia, Response.data[i].nombre_materia)
          this.evalError(Response.data[i].id_banner_docente, Response.data[i].nrc_materia)
        }
        /* -------------------------------------------------------------- */
        const studentRoleData = IberoHelpers.getUserLoginAuth(this.$store, this.$session.get('IberoJWTAdminLogin').emailCorporative)
        studentRoleData.then(dataRol => {
          const aux = dataRol.data[0].idUserType
          let role = 0
          aux.map(function (value) {
            if (value.Cod_Role === 'EST') {
              role = value.Id_Role
            }
          })
          /* -------------------------------------------------------------- */
          let formType = 0
          const actualPeriodType = this.period.substring(4, 6)
          const actualPeriod = this.period.substring(0, 4)
          /*
                10 - 20 (pregrado)
                11 -12- 13- 16 y 17 (pregrado virtual)
                31 - 32 - 33 -34 -35 (pregrado virtual)
                41 - 42- 43 -44 -45 (posgrado)
                51 -52 -53 -54 y 55 (posgrado)
                */
          if ((actualPeriodType == 10) || (actualPeriodType == 20)) {
            formType = 1
          } else if ((actualPeriodType > 10) && (actualPeriodType < 40)) {
            formType = 2
          } else if ((actualPeriodType >= 40) && (actualPeriodType < 60)) {
            formType = 3
          }
          this.formType = formType
          /* -------------------------------------------------------------- */
          const datEvalForm = IberoHelpers.getEvalForm(this.$store, role, actualPeriod, this.formType)
          datEvalForm.then(Response => {
            if (Response.data != '') {
              const currentDate = new Date()
              let currentDateSet
              currentDate.setDate(currentDate.getDate())
              currentDateSet = currentDate.getFullYear() + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2) + '-' + ('0' + currentDate.getDate()).slice(-2)
              let d1 = Response.data[0].Date_Form_Start.split('-')
              let d2 = Response.data[0].Date_Form_End.split('-')
              let c = currentDateSet.split('-')
              /* -------------------------------------------------------------- */
              let from = new Date(d1[0], parseInt(d1[1]) - 1, d1[2])
              let to = new Date(d2[0], parseInt(d2[1]) - 1, d2[2])
              let check = new Date(c[0], parseInt(c[1]) - 1, c[2])
              /* -------------------------------------------------------------- */
              if ((check > from) && (check < to)) {
                this.getFormId(role, actualPeriod, formType)
              } else {
                this.isBadDate = true
                this.iconLoad = false
              }
            } else {
              this.evalsExist = false
              this.iconLoad = false
            }
          })
        })
      } else {
        this.evalsExist = false
        this.iconLoad = false
      }
    })
    loader.hide()
  },
}
</script>